/**
 * Connection Commands.
 * http://docs.octoprint.org/en/master/api/connection.html#get-connection-settings
 */
export enum ConnectionCommand {
  connect = 'connnect',
  disconnect = 'disconnect',
  fake_ack = 'fake_ack'
}
